var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFace3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_2701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.15313 5.30191C2.22915 7.83946 1.47725 11.163 1.07918 14.3967C0.747462 17.1138 0.636889 19.9209 1.43302 22.5258C2.6051 26.3658 5.70116 29.3075 9.2174 30.7447C12.7336 32.1819 16.6258 32.2493 20.3411 31.6205C26.9534 30.5202 32.4379 24.21 32.7917 16.9791C33.3446 6.37981 23.592 -1.07563 14.348 0.137001C10.5222 0.631036 6.56363 2.09069 4.15313 5.30191Z",
    fill: "#FBE250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0014 5.16618C24.763 2.38162 20.4727 1.25881 17.8853 1.68548C17.4872 1.75285 17.642 2.33671 17.9737 2.38162C19.4996 2.58373 20.8486 2.87566 22.2419 3.61671C23.3918 4.22303 24.2101 5.27846 25.3379 5.88478C25.8023 6.1318 26.2225 5.63776 26.0014 5.16618Z",
    fill: "#FBE250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0425 6.60443C26.7108 6.55952 26.556 7.05355 26.7772 7.27812C27.2195 7.72724 27.7281 8.08654 28.1262 8.60303C28.5463 9.16443 28.7896 9.83812 29.2098 10.3995C29.4752 10.7588 29.9617 10.4444 29.9838 10.0627C30.0944 8.49075 28.4137 6.76162 27.0204 6.60443H27.0425Z",
    fill: "#FBE250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3449 10.6646C7.95647 10.8667 8.48723 14.3699 10.765 14.5271C13.0429 14.6618 13.5515 10.3951 10.3449 10.6646Z",
    fill: "#25368D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.323 11.338C9.83651 10.844 9.15096 11.7647 9.74805 12.1015C10.2125 12.371 10.7211 11.7422 10.323 11.338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3312 10.6646C19.9428 10.8667 20.4736 14.3699 22.7514 14.5271C25.0292 14.6618 25.5378 10.3951 22.3312 10.6646Z",
    fill: "#25368D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3758 11.338C21.8892 10.844 21.2037 11.7647 21.8008 12.1015C22.2652 12.371 22.7738 11.7422 22.3758 11.338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.4355,
    y: 19.1992,
    width: 8,
    height: 1.6,
    rx: 0.8,
    fill: "#25368D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_2701"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.835938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFace3);
export default __webpack_public_path__ + "static/media/icon-face-3.9bfb36a47498aad11555196359147fac.svg";
export { ForwardRef as ReactComponent };